<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Sales Dashboard</h4>
                <p class="text-subtitle-1">Dashboard</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <PaymentsPerMonthChart/>
            </v-col>
            <v-col cols="12" md="6">
                <PaymentsPerWeekChart/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <CustomersPerWeekChart/>
            </v-col>
            <v-col cols="12" md="6">
                <CustomersPerMonthChart/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet>
                    <div class="mb-2 font-weight-bold">Top 10 Customers Overall</div>
                    <TopCustomersOverallChart/>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="6">
                <v-sheet>
                    <div class="mb-2 font-weight-bold">Top 10 Customers Last 3 Months</div>
                    <TopCustomersPerMonthChart/>
                </v-sheet>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import TopCustomersOverallChart from '../../components/Sales/TopCustomersOverallChart.vue';
import CustomersPerMonthChart from '../../components/charts/CustomersPerMonthChart.vue';
import PaymentsPerMonthChart from '../../components/charts/PaymentsPerMonthChart.vue';
import PaymentsPerWeekChart from '../../components/charts/PaymentsPerWeekChart.vue';
import CustomersPerWeekChart from '../../components/charts/CustomersPerWeekChart.vue';
import TopCustomersPerMonthChart from '../../components/charts/TopCustomersPerMonthChart.vue';

export default {
    components: {
    TopCustomersOverallChart,
    CustomersPerMonthChart,
    PaymentsPerMonthChart,
    PaymentsPerWeekChart,
    CustomersPerWeekChart,
    TopCustomersPerMonthChart
},
    methods: {

    }
}
</script>

<style>

</style>